import axios from 'axios';
import Session from "supertokens-web-js/recipe/session";
import {Conversation, Message} from "@/models/backend/MessageModels";
import {SearchResult} from "@/models/backend/SearchResult";
import {CustomerApiEndpoint, MessageApiEndpoint} from "@/beepallet.consts";
import {LocalStorageService} from "@/services/backend/LocalStorageService"; // Adjust the import path as needed


const apiClient = axios.create({
    baseURL: MessageApiEndpoint + '/api',
    headers: {
        'Content-Type': 'application/json',
    },
});


export const MessageService = {
    async sendMessage(conversationId: string, senderId: string, receiverId: string, content: string,  files: { filename: string; base64: string; contentType: string }[]): Promise<{ conversation: Conversation, message: Message }> {
        await Session.attemptRefreshingSession();
        LocalStorageService.clearOrderKeys();
        const response = await apiClient.post(`/message`, {
            conversationId,
            senderId,
            receiverId,
            content,
            files
        }, {
            withCredentials: true,
            headers: { "Content-Type": "application/json" }
        });
        return response.data;
    },


    async getConversationsToRespondToCount(): Promise<number> {
        await Session.attemptRefreshingSession();
        const cacheKey = 'pending_message_count';

        const totalInCache = LocalStorageService
            .getItemWithExpiration<{total: number}>(cacheKey);
        if(totalInCache) return totalInCache.total;

        const response = await apiClient.get(`/conversation/pending/count`, {
            withCredentials: true
        });
        LocalStorageService.saveItemWithExpiration(cacheKey, response.data, 5);

        return response.data.total;
    },

    async getConversationMessages(conversationId: string, limit?: number, offset?: number): Promise<{ conversation: Conversation, messages: SearchResult<Message> } | null> {
        await Session.attemptRefreshingSession();
        const params: any = {
            conversationId,
            pagination: { limit: 100, offset: 0 }
        };
        if (limit !== undefined) params.pagination.limit = limit;
        if (offset !== undefined) params.pagination.offset = offset;

        const response = await apiClient.get(`/messages/conversation`, {
            withCredentials: true,
            params }
        );
        return response.data;
    }
};